import React from "react";
import CompactLoaderButton from "./CompactLoaderButton";
import powerBiLogo from "../assets/power-bi.svg";
import { ANALYTICAL_TOOL_URL } from "../routes/constants";

const AnalyticalToolButton: React.FC = () => {
  const openTool = () => {
    window.open(ANALYTICAL_TOOL_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <CompactLoaderButton
      text="Navigate To Analytical Tool"
      onClick={openTool}
      isLoading={false}
      type="button"
      leadingIconSrc={powerBiLogo}
    />
  );
};

export default AnalyticalToolButton;
